<div class="placeholder-wrapper"
     [ngClass]="{'stopped': !shouldShowPlaceholder(), 'running': shouldShowPlaceholder()}">
  <achoo-loader *ngIf="shouldShowPlaceholder()"
                [facebookPlaceholder]="facebookPlaceholder"
                [normalPlaceholder]="normalPlaceholder"
                [warningMessage]="warningMessage"
                [showWarningMessage]="showWarningMessage"
                [ngClass]="{'full-placeholder': isFullscreenLoader, 'partial-placeholder': isFullscreenLoader === false}">
  </achoo-loader>
  <ng-content></ng-content>
</div>



// WEBPACK FOOTER //
// ./src/app/core/achoo-placeholder/achoo-placeholder.component.html